var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14356 3.05394C7.7819 1.84025 10.3376 2.18665 11.5525 3.83911C12.8753 5.50952 12.5327 8.23453 10.7455 9.4418C10.9867 9.58677 11.2318 9.72662 11.482 9.85876C11.3216 10.2244 11.242 10.6183 11.2331 11.0173C10.2811 10.3707 9.10463 10.073 7.96023 10.1962C5.95239 10.3707 4.12931 11.8602 3.59688 13.809C3.47884 14.1875 3.49039 14.6057 3.30949 14.9637C3.11705 15.2793 2.63466 15.2626 2.39731 15.0073C2.30878 14.8508 2.31648 14.6622 2.32418 14.489C2.54613 12.272 4.09467 10.2898 6.1551 9.46618C5.50079 8.93246 4.93116 8.25378 4.69894 7.42627C4.20628 5.86234 4.77335 3.99178 6.14356 3.05394Z",
    fill: "#256EF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4311 10.5198C12.5966 10.0053 13.4229 10.0926 13.5037 10.6173C13.5499 11.2049 13.505 11.7951 13.5281 12.3827C14.1426 12.4404 14.7713 12.3249 15.3768 12.4468C15.89 12.5943 15.8528 13.3911 15.3332 13.5014C14.7418 13.5784 14.14 13.5181 13.5447 13.5373C13.4819 14.148 13.5704 14.7651 13.4934 15.3745C13.3408 15.8672 12.5658 15.8787 12.417 15.3784C12.3234 14.769 12.4183 14.1493 12.3606 13.5373C11.7614 13.5232 11.1584 13.5732 10.5619 13.5052C10.0551 13.3898 10.0269 12.5789 10.5272 12.4211C11.1405 12.3506 11.7601 12.416 12.376 12.3878C12.4145 11.7668 12.317 11.133 12.4311 10.5198Z",
    fill: "#256EF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowBlue);
export default __webpack_public_path__ + "static/media/follow-blue.49dc8dcb78381293b2be0fe498edb1a8.svg";
export { ForwardRef as ReactComponent };